export default __webpack_public_path__ + "static/media/bids6.e26d0d0c.png";